import type { Storage } from '@app/types'

export class StorageService implements Storage {
  setItem (key: string, data: string): void {
    localStorage.setItem(key, data)
  }

  getItem (key: string): string | null {
    return localStorage.getItem(key)
  }

  removeItem (key: string): void {
    localStorage.removeItem(key)
  }
}

const storageServiceInstance = new StorageService()

export default storageServiceInstance
